
import { useState, useRef, useEffect } from 'react';

interface UseAudioLevelMonitorProps {
  analyser: AnalyserNode | null;
  isMonitoring: boolean;
}

export const useAudioLevelMonitor = ({ 
  analyser, 
  isMonitoring 
}: UseAudioLevelMonitorProps) => {
  const [audioLevel, setAudioLevel] = useState(0);
  const audioLevelTimerRef = useRef<number | null>(null);
  
  // Start monitoring audio levels
  const startAudioLevelMonitor = () => {
    if (!analyser) return;
    
    const dataArray = new Uint8Array(analyser.frequencyBinCount);
    
    audioLevelTimerRef.current = window.setInterval(() => {
      analyser.getByteFrequencyData(dataArray);
      
      // Calculate the average level
      let sum = 0;
      for (let i = 0; i < dataArray.length; i++) {
        sum += dataArray[i];
      }
      const avg = sum / dataArray.length;
      const level = Math.min(100, Math.round((avg / 255) * 100));
      
      setAudioLevel(level);
    }, 100);
  };
  
  // Stop monitoring audio levels
  const stopAudioLevelMonitor = () => {
    if (audioLevelTimerRef.current) {
      clearInterval(audioLevelTimerRef.current);
      audioLevelTimerRef.current = null;
      setAudioLevel(0);
    }
  };
  
  // Start or stop monitoring based on isMonitoring
  useEffect(() => {
    if (isMonitoring) {
      startAudioLevelMonitor();
    } else {
      stopAudioLevelMonitor();
    }
    
    return () => {
      stopAudioLevelMonitor();
    };
  }, [isMonitoring, analyser]);
  
  return {
    audioLevel
  };
};
